export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/apps/alerts.afdce49.svg";